module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/zh-hant_hokkaido-0f02bc8b182145855003f775920ab78d.jpg";